module.exports = __webpack_public_path__ + "img/mouse.5e3b2226.svg";